export default {
  NOTIFICATION_DETAILS_LIST_REQUEST: 'APP/NOTIFICATIONDETAILS/NOTIFICATION_DETAILS_LIST_REQUEST',
  NOTIFICATION_DETAILS_LIST_SUCCESS: 'APP/NOTIFICATION_DETAILS/NOTIFICATION_DETAILS_LIST_SUCCESS',
  NOTIFICATION_DETAILS_LIST_ERROR: 'APP/NOTIFICATION_DETAILS/NOTIFICATION_DETAILS_LIST_ERROR',
};
